module.exports = __webpack_public_path__ + "media/images/nist_logo_centered_rev-d58f48e428ec41e35654bccae479546d.svg";